import React, { useState } from "react";
import "./modalstyle.css";
import Button from "../Button/Button";

function Modal({
  modalTitle,
  closeButtonName,
  actionButtonName,
  onClose,
  onSubmit,
}) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    modalTitle: modalTitle,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    const { firstName, email, phone, message } = formData;
    if (
      !firstName.trim() ||
      !email.trim() ||
      !phone.trim() ||
      !message.trim()
    ) {
      alert("Please fill all required fields before submitting.");
      return
    }

    // Close modal instantly when submitting
    const modalElement = document.getElementById("staticBackdrop");
    if (modalElement && window.bootstrap) {
      const modal =
        window.bootstrap.Modal.getInstance(modalElement) ||
        new window.bootstrap.Modal(modalElement);
      modal.hide();
    }

    await postSummaryToDiscord(formData);
    onSubmit(formData);

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
      modalTitle: modalTitle,
    });
  };

  return (
    <div
      className="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              {modalTitle}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label={closeButtonName || "Close"}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col">
                  <label htmlFor="firstName" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="custom-modal-input"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label htmlFor="lastName" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="custom-modal-input"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mb-3 custom-modal-email-gap">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="custom-modal-input"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="phone" className="form-label">
                  Phone Number
                </label>
                <input
                  type="tel"
                  className="custom-modal-input"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  className="custom-modal-input"
                  name="message"
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="new-modal-footer">
                <Button text={actionButtonName} size="discord" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;

async function postSummaryToDiscord(formData) {
  try {
    const pseudoname = "chatgpt";
    const url =
      "https://discord.com/api/webhooks/1162713198533820467/bgCCcBUBwJxdDGs46LD0MTXH_9rZRrmwy7O821c3YcCFKVSiqIrGl6jjyY1ZLCLZaGdX";
    const content = `Query: ${formData.modalTitle}\n\nFirst Name: ${formData.firstName}\nLast Name: ${formData.lastName}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nMessage: ${formData.message}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: pseudoname,
        content: content,
      }),
    });
    await response.text();
  } catch (err) {
    // silently handle error
  }
}
